// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Bk-z","zenCrossSiteLabel":"Ck-z","vrsnlCrossSiteLabel":"Dk-z"};